import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { UserPartial } from 'user';

import { userActions } from '../../store/modules/user';

const useUpdateUserHandler = () => {
  const dispatch = useDispatch();
  const handler = useCallback(
    (user: UserPartial) =>
      dispatch(userActions.updateUserAndShowNotification(user)),
    []
  );

  return handler;
};

export default useUpdateUserHandler;
